function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

$(document).ready(function(){
  
  $(document).on("click","[data-atc-button]",function(e){
    	e.preventDefault();
    	var cur_target = e.target;
    	var variantid =	$(cur_target).attr('data-variantid');
        $.ajax({
          url		:	"/cart/add.js",
          method	:	"POST",
          dataType	:	"JSON",
          data		:	{id : variantid, quantity : 1},
          success	:	function(data){
            	window.location = "/checkout";
          },
          error		:	function(error){
            
          }
        });
    
  });

    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
      isOnScreen($(".non-sticky-atc-button").eq(1))||
      isOnScreen($(".non-sticky-atc-button").eq(2)) ||
      isOnScreen($(".non-sticky-atc-button").eq(3)) ||
      isOnScreen($(".non-sticky-atc-button").eq(4)) ||
      isOnScreen($(".non-sticky-atc-button").eq(5))||
      isOnScreen($(".non-sticky-atc-button").eq(6)) ||
      isOnScreen($(".non-sticky-atc-button").eq(7)) ) {
      $(".sticky-atc-button").fadeOut(10);

      } else {
      $(".sticky-atc-button").fadeIn(10);
      }
      
      $(window).on('scroll',function(){
        if(  isOnScreen($(".non-sticky-atc-button").eq(0)) ||
           isOnScreen($(".non-sticky-atc-button").eq(1))||
           isOnScreen($(".non-sticky-atc-button").eq(2)) ||
           isOnScreen($(".non-sticky-atc-button").eq(3)) ||
           isOnScreen($(".non-sticky-atc-button").eq(4)) ||
           isOnScreen($(".non-sticky-atc-button").eq(5))||
           isOnScreen($(".non-sticky-atc-button").eq(6)) ||
           isOnScreen($(".non-sticky-atc-button").eq(7)) ) {
          $(".sticky-atc-button").fadeOut(10);

        } else {
          $(".sticky-atc-button").fadeIn(10);
        }


        if( isOnScreen($("[video-iframe2]").eq(0)) && $("[video-iframe2]").attr("src").trim() == "" ){
          var datasrc = $("[video-iframe2]").attr('data-src');
          $("[video-iframe2]").attr('src',datasrc);
        }

        if( isOnScreen($("[video-iframe1]").eq(0)) && $("[video-iframe1]").attr("src").trim() == "" ){
          var datasrc = $("[video-iframe1]").attr('data-src');
          $("[video-iframe1]").attr('src',datasrc);
        }
      });	
  
      
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
      //console.log(scroll);
      if (scroll >= 50) {
          //console.log('a');
          $(".header").addClass("change");
      } else {
          //console.log('a');
          $(".header").removeClass("change");
      }
    });
    $('.testimonial_slider').slick({
      slidesToShow:3,
      slidesToScroll: 3,
      arrows: true,
      infinite: true,
      dots:true,
      prevArrow: '<button class="slick-prev slick-arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow: '<button class="slick-next slick-arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
   
    
    $('.accordion .toggle').click(function(e) {
        e.preventDefault();
    
      let $this = $(this);
    
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.next().slideToggle(350);
      }
    });
    $('.accordion li a').on('click', function(){
        $(this).parent().siblings().removeClass('active');
        $(this).parent().toggleClass('active');
    });
  $('.what_include_wrapper .toggle').on('click',function(){
    $(this).parent().toggleClass('active');
  });
});


(function($) {
  "use strict"; // Start of use strict

  // Smooth scrolling using jQuery easing
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 56)
        }, 1000, "easeInOutExpo");
        return false;
      }
    }
    $(this).parent().siblings().removeClass('active');
    $(this).parent().addClass('active');
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function() {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#mainNav',
    offset: 56
  });

})(jQuery); // End of use strict
